import { Inject } from '@angular/core';

import type { UnaryFunction } from 'rxjs';
import { pipe, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { COMPANY_ID } from '@core/common-legacy';
import type { HttpApiErrorHandlerService } from '@core/http-legacy';
import { AuthService } from '@core/http-legacy';

export class ReferralsHttpApiErrorHandlerService implements HttpApiErrorHandlerService {
  constructor(
    private authService: AuthService,
    @Inject(COMPANY_ID) private currentCompanyId: number,
  ) {}

  public handleError(url: string): UnaryFunction<any, any> {
    return pipe(
      catchError(error => {
        if (401 === error.status) {
          this.authService.onUnauthorized(error);
        } else if (403 === error.status) {
          this.authService.onForbidden(error, this.currentCompanyId, url);
        }
        return throwError(error);
      }),
    );
  }
}
